/**
 * Payment Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AirtimeFeesDto } from './airtimeFeesDto';


export interface AirtimeCostReportDtoNotPersisted { 
    exchangeRateUsd?: number;
    exchangeRateEur?: number;
    exchangeRateCad?: number;
    comType: AirtimeCostReportDtoNotPersisted.ComTypeEnum;
    year: number;
    month: AirtimeCostReportDtoNotPersisted.MonthEnum;
    actualFees1: AirtimeFeesDto;
    actualFees2?: AirtimeFeesDto;
    calculatedFees1: AirtimeFeesDto;
    calculatedFees2?: AirtimeFeesDto;
    comProvider1?: AirtimeCostReportDtoNotPersisted.ComProvider1Enum;
    comProvider2?: AirtimeCostReportDtoNotPersisted.ComProvider2Enum;
    startDate: string;
    endDate: string;
    currency: AirtimeCostReportDtoNotPersisted.CurrencyEnum;
}
export namespace AirtimeCostReportDtoNotPersisted {
    export const ComTypeEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeEnum = typeof ComTypeEnum[keyof typeof ComTypeEnum];
    export const MonthEnum = {
        January: 'JANUARY',
        February: 'FEBRUARY',
        March: 'MARCH',
        April: 'APRIL',
        May: 'MAY',
        June: 'JUNE',
        July: 'JULY',
        August: 'AUGUST',
        September: 'SEPTEMBER',
        October: 'OCTOBER',
        November: 'NOVEMBER',
        December: 'DECEMBER'
    } as const;
    export type MonthEnum = typeof MonthEnum[keyof typeof MonthEnum];
    export const ComProvider1Enum = {
        GroundControl: 'GROUND_CONTROL',
        MetOcean: 'MET_OCEAN',
        Globalstar: 'GLOBALSTAR',
        Orbcomm: 'ORBCOMM',
        IridiumJapan: 'IRIDIUM_JAPAN'
    } as const;
    export type ComProvider1Enum = typeof ComProvider1Enum[keyof typeof ComProvider1Enum];
    export const ComProvider2Enum = {
        GroundControl: 'GROUND_CONTROL',
        MetOcean: 'MET_OCEAN',
        Globalstar: 'GLOBALSTAR',
        Orbcomm: 'ORBCOMM',
        IridiumJapan: 'IRIDIUM_JAPAN'
    } as const;
    export type ComProvider2Enum = typeof ComProvider2Enum[keyof typeof ComProvider2Enum];
    export const CurrencyEnum = {
        Usd: 'USD',
        Eur: 'EUR',
        Cad: 'CAD'
    } as const;
    export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];
}


export type ComTypeEnum = typeof AirtimeCostReportDtoNotPersisted.ComTypeEnum[keyof typeof AirtimeCostReportDtoNotPersisted.ComTypeEnum];
export type MonthEnum = typeof AirtimeCostReportDtoNotPersisted.MonthEnum[keyof typeof AirtimeCostReportDtoNotPersisted.MonthEnum];
export type ComProvider1Enum = typeof AirtimeCostReportDtoNotPersisted.ComProvider1Enum[keyof typeof AirtimeCostReportDtoNotPersisted.ComProvider1Enum];
export type ComProvider2Enum = typeof AirtimeCostReportDtoNotPersisted.ComProvider2Enum[keyof typeof AirtimeCostReportDtoNotPersisted.ComProvider2Enum];
export type CurrencyEnum = typeof AirtimeCostReportDtoNotPersisted.CurrencyEnum[keyof typeof AirtimeCostReportDtoNotPersisted.CurrencyEnum];
